import { useEffect, useSyncExternalStore } from "react";

const subscribe = () => () => {};

/**
 * Small utility hooks to get the status of hydration. This is useful in
 * order to only have components render purely client side for example.
 */
export const useHydrated = () => {
  const hydrated = useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );

  useEffect(() => {
    // oxlint-disable-next-line no-underscore-dangle
    window.__REACT_HYDRATED__ = true;
  }, []);

  return hydrated;
};
